import React, { useEffect, useRef } from 'react';
import cn from 'classnames';

import { formatNumber, formatSubPageText } from 'utils';
import { CLUSTER_HEADER_CATEGORY } from 'utils/constant';

import classes from './careerClusterHeaderTitle.module.css';

const CareerClusterHeaderTitle = ({
  subPageName,
  title,
  showJobsCount = false,
  noH1Tag = false,
  subPageTextSmall = true,
  jobTitleArticle,
  jobCount = '',
  getPageTitle,
  metadataH1,
}) => {
  const formattedSubPageName = formatSubPageText(subPageName, CLUSTER_HEADER_CATEGORY.CAREER);

  const TitleTag = noH1Tag ? 'p' : 'h1';
  const content = () => {
    if (subPageTextSmall) {
      return (
        <>
          <span className="title text-break">{`${title}`}</span>
          {formattedSubPageName && (
            <span
              className={cn(classes.subPageName, 'd-inline')}
            >{` ${formattedSubPageName}`}</span>
          )}
        </>
      );
    }

    if (subPageName === 'best-states')
      return `Best states for ${jobTitleArticle?.toLowerCase()} ${title?.toLowerCase()}`;
    if (subPageName === 'best-cities')
      return `Best cities for ${jobTitleArticle.toLowerCase()} ${title.toLowerCase()}`;
    if (subPageName === 'what-they-do') return `What Does ${jobTitleArticle} ${title} Do?`;
    if (subPageName === 'how-to-become')
      return `How to become ${jobTitleArticle?.toLowerCase?.()} ${title?.toLowerCase?.()}`;
    if (subPageName === 'jobs') return `${title} Jobs Near Me`;
    if (subPageName === 'remote-jobs') return `${title} Remote Jobs`;
    if (subPageName === 'overview') return metadataH1;
    if (subPageName === 'certifications') return metadataH1;
    if (subPageName === 'faqs') return metadataH1;
    if (subPageName === 'compare') return metadataH1 || `${title} Comparisons`;
    if (subPageName === 'how-to-hire') return metadataH1;
    if (subPageName === 'sitemap-location-level') return metadataH1;
    if (subPageName === 'education' && metadataH1) return metadataH1;
    if (subPageName === 'salary') return `${title} salary`;
    if (subPageName === 'job-description' && metadataH1) return metadataH1;
    if (subPageName === 'career-path' && metadataH1) return metadataH1;
    if (subPageName === 'trends' && metadataH1) return metadataH1;
    return `${title} ${formattedSubPageName}`;
  };
  const isJobsPage = subPageName?.toLowerCase()?.includes('jobs');
  const hasJobs = jobCount > 0 && jobCount !== '';
  const titleRef = useRef(null);

  useEffect(() => {
    if (getPageTitle) {
      const text = titleRef?.current?.textContent;
      getPageTitle(subPageTextSmall ? title : text);
    }
  }, [getPageTitle]);

  return (
    <>
      {(isJobsPage && hasJobs) || showJobsCount ? (
        <div
          ref={titleRef}
          className={cn(
            'd-flex align-items-center flex-wrap flex-fill z-mt-16 z-mt-md-36 z-mb-36',
            classes['max-width-860']
          )}
        >
          <TitleTag className={cn(classes['career-cluster-header-title-with-jobs'], 'mb-0')}>
            {content()}
          </TitleTag>
          &nbsp;&nbsp;
          <span
            className={cn('d-inline', classes['career-cluster-header-title-with-jobs'])}
          >{`- ${formatNumber(jobCount)} Jobs`}</span>
        </div>
      ) : (
        <TitleTag
          className={cn(classes['career-cluster-header-title'], 'z-mt-16 z-mt-md-36 z-mb-36')}
          ref={titleRef}
        >
          {content()}
        </TitleTag>
      )}
    </>
  );
};

export default CareerClusterHeaderTitle;
